import React, {PureComponent} from 'react'

class Contact extends PureComponent {
	feedback = () => {
		var elementUsername = this.refs.name.value;
		var elementMobile = this.refs.mobile.value;
		var elementContent = this.refs.content.value;
		if (!elementUsername.length) {
			alert('请输入姓名');
			return
		}
		if (!elementMobile.length) {
			alert('请输入电话');
			return
		}
		if (!elementContent.length) {
			alert('请输入问题');
			return
		}
		fetch('https://tmdapi.gochinatv.com/tmdapi/v1/feedback', {
			method: 'POST',
			headers: {'Content-Type': "application/json"},
			body: JSON.stringify({
				name: elementUsername,
				mobile: elementMobile,
				description: elementContent
			})
		}).then(res => res.json()).then(json => {
			if (json.status === 200) {
				alert('提交成功，24小时内会有专业人士与您取得联系')
			} else {
				alert('提交失败，请稍候重试')
			}
		})
	};

	render() {
		return (
			<div style={{
				backgroundColor: '#dbe5f3',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center'
			}}>
				<span style={{fontSize: zoom(48) + 'px', color: '#4e4e4e', marginTop: zoom(75)}}>问题咨询</span>
				<span style={{fontSize: zoom(36) + 'px', color: '#989898', marginTop: zoom(30) + 'px'}}>如果您有任何问题欢迎和我们联系</span>
				<div style={{marginTop: zoom(120) + 'px'}}>
					<div>
						<span style={{fontSize: zoom(24) + 'px', color: '#4e4e4e', marginRight: zoom(35) + 'px'}}>姓名*</span>
						<input style={{
							width: zoom(400) + 'px',
							height: zoom(50) + 'px',
							fontSize: zoom(24) + 'px',
							color: '#4e4e4e'
						}} ref={'name'}/>
					</div>
					<div style={{marginTop: zoom(40) + 'px'}}>
						<span style={{fontSize: zoom(24) + 'px', color: '#4e4e4e', marginRight: zoom(35) + 'px'}}>电话*</span>
						<input style={{
							width: zoom(400) + 'px',
							height: zoom(50) + 'px',
							fontSize: zoom(24) + 'px',
							color: '#4e4e4e'
						}} ref={'mobile'}/>
					</div>
					<div style={{marginTop: zoom(40) + 'px', display: 'flex'}}>
						<span style={{fontSize: zoom(24) + 'px', color: '#4e4e4e', marginRight: zoom(35) + 'px'}}>问题*</span>
						<textarea style={{
							width: zoom(1020) + 'px',
							height: zoom(216) + 'px',
							fontSize: zoom(24) + 'px',
							color: '#4e4e4e'
						}} ref={'content'}/>
					</div>
				</div>
				<div style={{
					fontSize: zoom(26) + 'px',
					color: 'white',
					backgroundColor: '#ff6956',
					lineHeight: zoom(60) + 'px',
					width: zoom(380) + 'px',
					textAlign: 'center',
					borderRadius: zoom(8) + 'px',
					marginTop: zoom(105) + 'px',
					marginBottom: zoom(90) + 'px'
				}} onClick={this.feedback}>提交
				</div>
			</div>
		)
	}
}

const zoom = (size) => {
	return window.innerWidth * size / 1920
};

export default Contact


// WEBPACK FOOTER //
// ./src/Contact.js